import { cssVarV2 } from '@blocksuite/affine-shared/theme';

const rowSeparatorShadow = `inset 0 -1px 0 ${cssVarV2.database.border}`;
const cellSeparatorShadow = `inset -1px 0 0 ${cssVarV2.database.border}, ${rowSeparatorShadow}`;

export function applyVirtualTableRowSeparator(
  element: HTMLElement | null | undefined
) {
  if (!element) return;
  element.style.removeProperty('border-bottom');
  element.style.removeProperty('border-right');
  element.style.setProperty('box-shadow', rowSeparatorShadow);
  element.style.setProperty('box-sizing', 'border-box');
}

export function applyVirtualTableCellSeparators(
  element: HTMLElement | null | undefined
) {
  if (!element) return;
  element.style.removeProperty('border-bottom');
  element.style.removeProperty('border-right');
  element.style.setProperty('box-shadow', cellSeparatorShadow);
  element.style.setProperty('box-sizing', 'border-box');
}
